import React from 'react'
import {StyledFooter} from "../Footer/Footer.styled"
import { SocialContainer } from '../Flex/Flex.styled';


export const Footer = () => {
  return (
    <StyledFooter id="contact">
      <h1>Get in Touch With Me</h1>

      <div>
        <h3>Contact Me</h3>
        <a
          href="mailto:ibukunoluwaakintobi@gmail.com"
          rel="noreferrer noopener"
        >
          ibukunoluwaakintobi@gmail.com
        </a>
      </div>

      <div>
        <h3>Social Media</h3>
        <SocialContainer>
        <a href="https://www.linkedin.com/in/ibukunoluwa-akintobi-65262323a">
          Linkedin
        </a>
        <a href="https://github.com/MadeByIbukunoluwa" rel="noreferrer noopener">
         Github
        </a>
        <a href="https://twitter.com/ibkisthere" rel="noreferrer noopener">
          Twitter
        </a>
        </SocialContainer>
      </div>
      <p>
        Designed and developed by &copy; 2022 Ibukunoluwa Akintobi&trade; All
        Rights Reserved
      </p>
    </StyledFooter>
  );
}



